import React, { useEffect } from 'react';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-slate-100 max-w-4xl mx-auto my-10">
      <h1 className="text-4xl font-extrabold text-slate-900 mb-4 tracking-tight">Terms and Conditions</h1>
      <p className="text-slate-500 font-medium mb-12">Last Updated: April 1, 2026</p>
      
      <div className="text-slate-600 space-y-8 leading-relaxed">
        <p>
          Welcome to <strong className="text-indigo-600">pass-photo.in</strong>. By accessing or using our website, you agree to comply with and be bound by the following Terms and Conditions. If you do not agree with these terms, please do not use our service.
        </p>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">1. Description of Service</h2>
          <p>
            <strong>pass-photo.in</strong> is a free online web application that utilizes Artificial Intelligence to help users format, enhance, and generate passport-sized photos.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">2. User Responsibilities</h2>
          <p className="mb-2">By using our service, you agree that:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>You have the legal right and permission to use and upload the images you submit.</li>
            <li>You will not upload any images that are illegal, offensive, explicit, or violate the copyright or privacy rights of any third party.</li>
            <li>You are solely responsible for the content you upload and the generated photos you download.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">3. No Guarantee of Official Acceptance</h2>
          <p>
            While our AI is designed to match standard passport photo dimensions and background requirements, <strong>we do not guarantee</strong> that the photos generated by our tool will be accepted by official government bodies, passport agencies, or visa offices. It is your responsibility to verify that the generated photo meets the specific legal, dimensional, and lighting requirements of the country or organization you are applying to.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">4. Advertisements</h2>
          <p>
            To keep this service 100% free, <strong>pass-photo.in</strong> displays advertisements provided by third-party networks, such as Google AdSense. By using our website, you consent to the placement of such advertisements.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">5. Disclaimer of Warranties</h2>
          <p>
            Our service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, regarding the reliability, accuracy, or uninterrupted availability of the site or the AI processing tools.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">6. Limitation of Liability</h2>
          <p>
            In no event shall <strong>pass-photo.in</strong>, its developers (including DarkCoder), or its affiliates be liable for any direct, indirect, incidental, or consequential damages arising from the use of, or inability to use, our website or the generated photos. This includes any financial loss or application rejection due to photos generated via our platform.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-slate-800 mb-4">7. Right to Modify or Terminate Service</h2>
          <p>
            We reserve the right to modify, pause, or discontinue the website (or any part of it) at any time without prior notice. We may also update these Terms and Conditions periodically. Continued use of the website after updates constitutes your acceptance of the new terms.
          </p>
        </section>

        <section className="bg-indigo-50 border border-indigo-100 p-6 rounded-2xl mt-10">
          <h2 className="text-xl font-bold text-indigo-900 mb-2">8. Contact Us</h2>
          <p className="text-indigo-800 mb-4">
            If you have any questions regarding these Terms and Conditions, please reach out to us:
          </p>
          <p className="font-semibold text-indigo-600">Email: <a href="mailto:darkcoder.studio@gmail.com" className="hover:underline">darkcoder.studio@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
